import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FadeIn } from "@/components/common/FadeIn";
import api from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Please check your credentials.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-6" data-testid="admin-login-page">
      <FadeIn>
        <div className="w-full max-w-sm">
          <div className="text-center mb-10">
            <h1 className="font-heading text-2xl text-[#0A1128] mb-2">Admin Login</h1>
            <p className="text-sm text-[#8A94A6]">Rain Boy Fine Art Gallery Management</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-5" data-testid="admin-login-form">
            <div>
              <Label htmlFor="admin-email" className="text-xs uppercase tracking-[0.15em] text-[#8A94A6] mb-2 block">
                Email
              </Label>
              <Input
                id="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="rounded-none border-[#0A1128]/15"
                data-testid="admin-email-input"
                required
              />
            </div>
            <div>
              <Label htmlFor="admin-password" className="text-xs uppercase tracking-[0.15em] text-[#8A94A6] mb-2 block">
                Password
              </Label>
              <Input
                id="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="rounded-none border-[#0A1128]/15"
                data-testid="admin-password-input"
                required
              />
            </div>

            {error && <p className="text-red-500 text-sm" data-testid="admin-login-error">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#0A1128] text-white py-3 text-xs uppercase tracking-[0.2em] hover:bg-[#2c3e50] transition-colors disabled:opacity-50"
              data-testid="admin-login-submit"
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
        </div>
      </FadeIn>
    </div>
  );
}
